export default __webpack_public_path__ + "static/media/album-default.8a8830d6.png";